import { Alert, AlertProps } from "@mui/material";
import { FC } from "react";

export const MuiAlert: FC<AlertProps> = props => <Alert {...props} />;
